/* global Blockly */
/* global Util */

import CoreResponse from './CoreResponse';

// default/empty text block used as a auto-generated response block
const TextResponse = function () {
    let name = 'text_response';

    let blockInstance = CoreResponse({
        shape: Blockly.OUTPUT_SHAPE_ROUND,
        type: "String"
    });
    Blockly.Blocks[name] = blockInstance;

    Blockly.JavaScript[name] = function() {
        let code = this.getJavascriptCore();
        return [code, Blockly.JavaScript.ORDER_NONE];
    };
};

export default TextResponse;
